/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountCodeValidation
 */
export interface AccountCodeValidation {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AccountCodeValidation
     */
    currency?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof AccountCodeValidation
     */
    code?: ValidationMessage;
    /**
     * 
     * @type {number}
     * @memberof AccountCodeValidation
     */
    readonly index?: number;
}

export function AccountCodeValidationFromJSON(json: any): AccountCodeValidation {
    return AccountCodeValidationFromJSONTyped(json, false);
}

export function AccountCodeValidationFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountCodeValidation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'currency': !exists(json, 'currency') ? undefined : ValidationMessageFromJSON(json['currency']),
        'code': !exists(json, 'code') ? undefined : ValidationMessageFromJSON(json['code']),
        'index': !exists(json, 'index') ? undefined : json['index'],
    };
}

export function AccountCodeValidationToJSON(value?: AccountCodeValidation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'currency': ValidationMessageToJSON(value.currency),
        'code': ValidationMessageToJSON(value.code),
    };
}


